import React, { useEffect, useRef, useState } from 'react';
import { XIcon } from 'lucide-react';
import { liveNotifications } from '../data/content';
const VISIBLE_MS = 5000;
const HIDDEN_MS = 8000;
export function LiveToast() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const timeoutRef = useRef<number | undefined>(undefined);
  useEffect(() => {
    if (isDismissed) return;
    const schedule = (delay: number, next: () => void) => {
      timeoutRef.current = window.setTimeout(next, delay);
    };
    const show = () => {
      setIsVisible(true);
      schedule(VISIBLE_MS, hide);
    };
    const hide = () => {
      setIsVisible(false);
      schedule(HIDDEN_MS, () => {
        setIndex(prev => (prev + 1) % liveNotifications.length);
        show();
      });
    };
    schedule(HIDDEN_MS / 4, show);
    return () => window.clearTimeout(timeoutRef.current);
  }, [isDismissed]);
  if (isDismissed) return null;
  const item = liveNotifications[index];
  return <div aria-live="polite" className={`fixed bottom-4 left-4 z-[100] max-w-[calc(100vw-2rem)] transition-all duration-500 sm:max-w-sm ${isVisible ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'}`} data-id="element-154" data-mp="3dgv0pad15ehz">
      <div className="flex items-start gap-3 rounded-2xl border border-white/10 bg-ink-900 p-4 shadow-[0_18px_45px_rgba(0,0,0,0.6)]" style={{
      width: "325px",
      height: "85px"
    }} data-id="element-155" data-mp="2ynrh6xfvoqom">
        <span aria-hidden="true" className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-green-500 animate-livePulse" data-id="element-156" data-mp="2prsc1ijzaldz" />
        <div className="min-w-0" data-id="element-157" data-mp="2ks5y16wbt144">
          <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-green-400" data-id="element-158" data-mp="2fvp9wcp4mmr1">
            Compra en vivo
          </p>
          <p className="mt-1 text-sm font-semibold leading-snug text-white" data-id="element-159" data-mp="2ausw97ez3m8f">
            {item.name} de {item.city} compró {item.product}
          </p>
          <p className="mt-1 text-xs text-gray-400" data-id="element-160" data-mp="1w9dpdf8t1p1a">{item.time}</p>
        </div>
        <button type="button" onClick={() => setIsDismissed(true)} aria-label="Cerrar notificación" className="ml-auto shrink-0 rounded-full p-1 text-gray-400 transition-colors hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400" data-id="element-161" data-mp="1wbhxk9dqla7d">
          <XIcon className="h-4 w-4" data-id="element-162" data-mp="1s8241lwyrpyw" />
        </button>
      </div>
    </div>;
}